<div class="flex items-center justify-center w-full h-full">
  <div class="items-center justify-center w-full flex flex-col">
    <div class="flex items-center justify-center md:h-full">
      <div class="h-full">
        <img
          src="assets/svg/cfa-sante.svg"
          class="h-16 mx-auto mb-4"
          alt="Cfa santé"
        />
      </div>
    </div>
    <div
      class="flex items-center justify-center mt-4 md:h-full md:mt-0 relative"
    >
      <div class="h-full">
        <div *ngIf="isLoader">
          <mat-progress-spinner
            class="mx-auto mb-10"
            diameter="50"
            strokeWidth="5"
            mode="determinate"
            mode="indeterminate"
          ></mat-progress-spinner>
        </div>
        <p
          class="mx-auto text-sm text-percian-green lg:text-lg md:w-3/4"
          [ngClass]="isLoader ? 'text-center' : ''"
        >
          {{ text }}
        </p>
        <p
          class="pt-3 mx-auto text-xs text-percian-green lg:text-sm md:w-3/4"
          *ngIf="isClick"
          (click)="onClick($event)"
        >
          <u>{{ textClick }}</u>
        </p>
      </div>
      <!-- <div>
        <img src="assets/svg/flower.svg" class="absolute left-0 h-36" />
      </div> -->
    </div>
  </div>
</div>
